import { useEffect, useState } from 'react'
import { GetEEMBuildingsForOrganization } from '../services/AnnualPlanService'
import { type OrganizationOption } from '../models/requestObjects/CommonObjects'

interface UseEEMOrganizationBuildingOptionsType {
  buildings: OrganizationOption[]
  isLoading: boolean
}

export const useEEMOrganizationBuildingOptions = (organizationId: number): UseEEMOrganizationBuildingOptionsType => {
  const [buildings, setBuildings] = useState<OrganizationOption[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const getBuildingOptions = async (): Promise<void> => {
      setIsLoading(true)
      const buildings = await GetEEMBuildingsForOrganization(organizationId)
      setBuildings(buildings)
      setIsLoading(false)
    }

    void getBuildingOptions()
  }, [organizationId])

  return { buildings, isLoading }
}
